import { useState } from 'react'
import { Button } from 'components'
import { ProductLayoutCopyModal } from './ProductLayoutCopyModal'

type ShowState = [boolean, (value: boolean) => void]

export const ProductLayoutCopyButton = () => {
  const [show, setShow] = useState(false)

  const buttonText = '📦 Product Layout copy'

  return (
    <>
      <Button primary onClick={() => setShow(true)}>
        {buttonText}
      </Button>
      <ProductLayoutCopyModal show={[show, setShow] as ShowState} />
    </>
  )
}

export default ProductLayoutCopyButton
